export default __webpack_public_path__ + "static/media/posionedhide.25ccf0f2.png";